module.exports = __webpack_public_path__ + "img/reactivar icon.24ccc2c9.svg";